(function ($) {

    /**
     * Constructor
     *
     * @param options
     * @constructor
     */
    function BusinessContactForm(options) {
        console.log('BusinessContactForm initialization');

        if (!options) {
            throw new Error('No options passed to BusinessContactForm constructor');
        } else if (!options.isUserLoggedIn) {
            throw new Error('No option postType passed to constructor');
        } else if (!options.redirectURL) {
            throw new Error('No option redirectURL passed to constructor');
        }

        console.log(options);

        this.options = $.extend({}, Alerts.defaults, options);
        this.setup();
    }

    /**
     * Add events listeners
     */
    BusinessContactForm.prototype.setup = function () {
        let body = $('body');
        let self = this;

        body.on('click', '.contact-firm-button', function (event) {
            event.preventDefault();
            if (self.options.isUserLoggedIn === 'true') {
                $('#modal-message').hide();
                self.addDataToHiddenField(event.target);
            } else {
                window.location.href = self.options.redirectURL;
            }
        });
    }

    /**
     * Set business ID value to hidden modal field
     *
     * @param obj
     */
    BusinessContactForm.prototype.addDataToHiddenField = function (obj) {
        let businessID = $(obj).data('business-id');
        let firmName = $(obj).data('firm-name');

        let fd = new FormData();
        fd.append('businessID', businessID);
        this.sendRequest(fd);

        console.log(firmName);
        let modal = $('#contactmodal');
        modal.find('#input_5_11').val(businessID);
        modal.find('#modal_company_name').empty().append(firmName);
    }

    /**
     * Send AJAX request
     */
    BusinessContactForm.prototype.sendRequest = function (fd) {
        let self = this;
        console.log('Send request');
        console.log(fd);

        jQuery.ajax({
            type: 'POST',
            url: self.options.apiRoute,
            data: fd,
            processData: false,
            contentType: false,
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
                $('#message').hide().empty();
            },
            success: function (response) {
                self.parseResponse(response);
            },
            error: function (data) {
                console.log(data);
            }
        });
    }

    /**
     * Parse response
     *
     * @param response
     */
    BusinessContactForm.prototype.parseResponse = function (response) {
        console.log(response);
        if (response.status !== 'success') {
            $('#message').append(response.message).show();
            return;
        }

        if (response.is_form_already_sent === 'true') {
            $('#modal-message').show();
        }
    }

    BusinessContactForm.defaults = {};
    window.BusinessContactForm = BusinessContactForm;

})(jQuery);